import React from 'react';
import '../styles/PostBrief.css'

import {Link} from 'react-router-dom';

export class PostBrief extends React.Component {
  render() {
    const p = this.props.post;
    return (
      <div className={"post-brief"}>
        <h3>
        <Link to={`/post/${p.id}`}> {p.title} </Link>
        </h3>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/PostBrief.js